import { render, staticRenderFns } from "./HelpItemElement.vue?vue&type=template&id=230c9fb7&"
import script from "./HelpItemElement.vue?vue&type=script&lang=js&"
export * from "./HelpItemElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports